import Api from './Api'

export default {
  getPhone(data) {
    return Api().post('/wp-admin/admin-ajax.php?action=get_phone', data)
  },
  getForm(data) {
    return Api().post('/wp-admin/admin-ajax.php?action=feedback', data)
  },
}



// WEBPACK FOOTER //
// ./src/js/components/app/services/forms.js